module.exports = __webpack_public_path__ + "img/jackie_shroff.fdd38ee0.png";